/**
 * ATTENTION! This file is auto-generated for the 'elita' module.
 * Vite plugin placed is here: packages/platform/server/rpc-generator/generator.ts
 * Any manual changes will be overwritten on the next build.
*/

import { makeRepositoryProxy } from '@ayocore/platform/server/rpc/makeRepositoryProxy';
import { makeFunctionProxy } from '@ayocore/platform/server/rpc/makeFunctionProxy';
import type { RpcFunctionClient } from '@ayocore/platform/server/rpc/types';
import type { ElitaProductsRepository } from '../server/repositories/ElitaProductsRepository';
import type { ElitaSkusRepository } from '../server/repositories/ElitaSkusRepository';
import type { ElitaCategoriesRepository } from '../server/repositories/ElitaCategoriesRepository';
import type { ElitaPricesRepository } from '../server/repositories/ElitaPricesRepository';
import type { ElitaStockRepository } from '../server/repositories/ElitaStockRepository';
import type { ElitaWarehousesRepository } from '../server/repositories/ElitaWarehousesRepository';
import type { ElitaPriceTypesRepository } from '../server/repositories/ElitaPriceTypesRepository';
import type { ElitaRequisiteTypesRepository } from '../server/repositories/ElitaRequisiteTypesRepository';
import type { ElitaProductRequisitesRepository } from '../server/repositories/ElitaProductRequisitesRepository';
import type { ElitaAttributesRepository } from '../server/repositories/ElitaAttributesRepository';
import type { ElitaAttributeOptionsRepository } from '../server/repositories/ElitaAttributeOptionsRepository';
import type { ElitaArticleColorRepository } from '../server/repositories/ElitaArticleColorRepository';
import type { ElitaDealsRepository } from '../server/repositories/ElitaDealsRepository';

// Terminal methods configuration
const TERMINAL_METHODS = ["create","update","findById","deleteById","fetch","count","aggregate","aggregateBy","countGroups","meta","getInstance","columns","filters"];

type ElitaProductsRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<ElitaProductsRepository>;
export function useElitaProductsRepository(): ElitaProductsRepositoryClient { return makeRepositoryProxy<ElitaProductsRepositoryClient>('elita::ElitaProductsRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useElitaProductsRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const elitaProductsRepository = useElitaProductsRepository();

type ElitaSkusRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<ElitaSkusRepository>;
export function useElitaSkusRepository(): ElitaSkusRepositoryClient { return makeRepositoryProxy<ElitaSkusRepositoryClient>('elita::ElitaSkusRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useElitaSkusRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const elitaSkusRepository = useElitaSkusRepository();

type ElitaCategoriesRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<ElitaCategoriesRepository>;
export function useElitaCategoriesRepository(): ElitaCategoriesRepositoryClient { return makeRepositoryProxy<ElitaCategoriesRepositoryClient>('elita::ElitaCategoriesRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useElitaCategoriesRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const elitaCategoriesRepository = useElitaCategoriesRepository();

type ElitaPricesRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<ElitaPricesRepository>;
export function useElitaPricesRepository(): ElitaPricesRepositoryClient { return makeRepositoryProxy<ElitaPricesRepositoryClient>('elita::ElitaPricesRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useElitaPricesRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const elitaPricesRepository = useElitaPricesRepository();

type ElitaStockRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<ElitaStockRepository>;
export function useElitaStockRepository(): ElitaStockRepositoryClient { return makeRepositoryProxy<ElitaStockRepositoryClient>('elita::ElitaStockRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useElitaStockRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const elitaStockRepository = useElitaStockRepository();

type ElitaWarehousesRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<ElitaWarehousesRepository>;
export function useElitaWarehousesRepository(): ElitaWarehousesRepositoryClient { return makeRepositoryProxy<ElitaWarehousesRepositoryClient>('elita::ElitaWarehousesRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useElitaWarehousesRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const elitaWarehousesRepository = useElitaWarehousesRepository();

type ElitaPriceTypesRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<ElitaPriceTypesRepository>;
export function useElitaPriceTypesRepository(): ElitaPriceTypesRepositoryClient { return makeRepositoryProxy<ElitaPriceTypesRepositoryClient>('elita::ElitaPriceTypesRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useElitaPriceTypesRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const elitaPriceTypesRepository = useElitaPriceTypesRepository();

type ElitaRequisiteTypesRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<ElitaRequisiteTypesRepository>;
export function useElitaRequisiteTypesRepository(): ElitaRequisiteTypesRepositoryClient { return makeRepositoryProxy<ElitaRequisiteTypesRepositoryClient>('elita::ElitaRequisiteTypesRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useElitaRequisiteTypesRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const elitaRequisiteTypesRepository = useElitaRequisiteTypesRepository();

type ElitaProductRequisitesRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<ElitaProductRequisitesRepository>;
export function useElitaProductRequisitesRepository(): ElitaProductRequisitesRepositoryClient { return makeRepositoryProxy<ElitaProductRequisitesRepositoryClient>('elita::ElitaProductRequisitesRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useElitaProductRequisitesRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const elitaProductRequisitesRepository = useElitaProductRequisitesRepository();

type ElitaAttributesRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<ElitaAttributesRepository>;
export function useElitaAttributesRepository(): ElitaAttributesRepositoryClient { return makeRepositoryProxy<ElitaAttributesRepositoryClient>('elita::ElitaAttributesRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useElitaAttributesRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const elitaAttributesRepository = useElitaAttributesRepository();

type ElitaAttributeOptionsRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<ElitaAttributeOptionsRepository>;
export function useElitaAttributeOptionsRepository(): ElitaAttributeOptionsRepositoryClient { return makeRepositoryProxy<ElitaAttributeOptionsRepositoryClient>('elita::ElitaAttributeOptionsRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useElitaAttributeOptionsRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const elitaAttributeOptionsRepository = useElitaAttributeOptionsRepository();

type ElitaArticleColorRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<ElitaArticleColorRepository>;
export function useElitaArticleColorRepository(): ElitaArticleColorRepositoryClient { return makeRepositoryProxy<ElitaArticleColorRepositoryClient>('elita::ElitaArticleColorRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useElitaArticleColorRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const elitaArticleColorRepository = useElitaArticleColorRepository();

type ElitaDealsRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<ElitaDealsRepository>;
export function useElitaDealsRepository(): ElitaDealsRepositoryClient { return makeRepositoryProxy<ElitaDealsRepositoryClient>('elita::ElitaDealsRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useElitaDealsRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const elitaDealsRepository = useElitaDealsRepository();

type createDealFromLeadType = typeof import('../server/functions/createDealFromLead').createDealFromLead;
export const createDealFromLead: RpcFunctionClient<createDealFromLeadType> = makeFunctionProxy<createDealFromLeadType>('elita::createDealFromLead');
